/** @jsx jsx */
import { css, jsx } from "@emotion/core";

const Button = ({ btnText, btnIcon, onClick, isActive, btnImg }) => {
  return (
    <button onClick={onClick} className={isActive && "active"} css={styles}>
      <i className={btnIcon}></i>
      {btnImg && <img src={btnImg} alt="mixer" />}
      <p>{btnText}</p>
    </button>
  );
};

const styles = css`
  padding: 14px;
  background: #424e67;
  color: #fff;
  width: 120px;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 5px;
  &.active {
    background: #7877ff;
  }
  p {
    padding: 2px 0 0 0;
    margin-left: 5px;
  }
  img {
    width: 10px;
    height: 10px;
    display: block;
  }
`;

export default Button;
